<template>
  <!-- Priority indicator: directional icon + text label + color, so it is
       legible without relying on color perception. -->
  <span class="int-prio d-inline-flex align-center" :class="`text-${prioColor}`">
    <v-icon size="16">{{ prioIcon }}</v-icon>
    <span v-if="!iconOnly" class="text-capitalize ml-1">{{ priority }}</span>
  </span>
</template>

<script>
import { priorityColor, priorityIcon } from '@/theme/semantic';

export default {
  name: 'PriorityChip',
  props: {
    priority: { type: String, default: '' },
    iconOnly: { type: Boolean, default: false },
  },
  computed: {
    prioColor() {
      return priorityColor(this.priority);
    },
    prioIcon() {
      return priorityIcon(this.priority);
    },
  },
};
</script>

<style scoped>
.int-prio {
  font-size: 0.8rem;
  font-weight: 600;
}
</style>
